import { render, staticRenderFns } from "./InternalVideo.vue?vue&type=template&id=3a79935b&"
import script from "./InternalVideo.vue?vue&type=script&lang=js&"
export * from "./InternalVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports